import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const inr = (n) => "₹" + Math.round(n || 0).toLocaleString("en-IN");
export const compact = (n) => new Intl.NumberFormat("en-IN", { notation: "compact" }).format(n || 0);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function streamAI(payload, { onDelta, onDone, onError }) {
  try {
    const res = await fetch(`${API}/ai/analyze`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload),
    });
    if (!res.ok || !res.body) {
      onError?.(`AI request failed (${res.status})`);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const parts = buf.split("\n\n");
      buf = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const data = JSON.parse(line.slice(5).trim());
        if (data.delta) onDelta?.(data.delta);
        if (data.error) onError?.(data.error);
        if (data.done) onDone?.(data);
      }
    }
  } catch (e) {
    onError?.(e.message || "Stream failed");
  }
}
